import { ApiRequest, Reducer } from 'store';

export const initialState = {
    assetNatures: {
        isFetching: false,
        didInvalidate: true,
    } as ApiRequest<number[]>,
    assetFamilies: {
        isFetching: false,
        didInvalidate: true,
    } as ApiRequest<number[]>,
} as const;

export type ReferentialState = typeof initialState;

export const ReferentialReducer: Reducer<ReferentialState> = (state = initialState, action) => {
    switch (action.type) {
        case '@REFERENTIAL/FETCH_ASSET_NATURES':
            return {
                ...state,
                assetNatures: {
                    isFetching: true,
                    didInvalidate: true,
                },
            };

        case '@REFERENTIAL/FETCH_ASSET_NATURES_SUCCESS':
            return {
                ...state,
                assetNatures: {
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.assetnatureIds,
                },
            };

        case '@REFERENTIAL/FETCH_ASSET_NATURES_FAILURE':
            return {
                ...state,
                assetNatures: {
                    isFetching: false,
                    didInvalidate: true,
                },
            };

        case '@REFERENTIAL/FETCH_ASSET_FAMILIES':
            return {
                ...state,
                assetFamilies: {
                    isFetching: true,
                    didInvalidate: true,
                },
            };

        case '@REFERENTIAL/FETCH_ASSET_FAMILIES_SUCCESS':
            return {
                ...state,
                assetFamilies: {
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.assetFamilyIds,
                },
            };

        case '@REFERENTIAL/FETCH_ASSET_FAMILIES_FAILURE':
            return {
                ...state,
                assetFamilies: {
                    isFetching: false,
                    didInvalidate: true,
                },
            };

        default:
            return state;
    }
};
